import { createDrawerNavigator } from "@react-navigation/drawer";
import { MainStackParamList } from "./Navigation.types";
import { MyGamesScreen } from "../screens/my-games";
import { SideNav } from "../layout/components/side-menu";
import { StatsScreen } from "../screens/stats";
import { GameScreen } from "../screens/game";
import { AuthGuard } from "../components/guard";
import { ProfileScreen } from "../screens/profile";
import { EqipaCardScreen } from "../screens/eqipa-card";
import { MyGroupsScreen } from "../screens/my-groups";
import { CreateGroupScreen } from "../screens/create-group";
import { JoinGroupScreen } from "../screens/join-group";
import { NewGameScreen } from "../screens/new-game";
import EditGameScreen from "../screens/edit-game/EditGameScreen";
import HomeScreenRM from "../screens/home_remastered/HomeScreen";
import GroupScreenRM from "../screens/group_remastered/GroupScreen";
import AddPlayerScreen from "../screens/add-player/AddPlayerScreen";
import CompetitionsListScreen from "../screens/competitions-list/CompetitionsListScreen";
import CompetitionDetailScreen from "../screens/competition-detail/CompetitionDetailScreen";

const Main = createDrawerNavigator<MainStackParamList>();

export default function MainStack() {
  return (
    <AuthGuard>
      <Main.Navigator
        screenOptions={{ headerShown: false }}
        backBehavior="history"
        initialRouteName="home_remastered"
        drawerContent={(props) => <SideNav {...props} />}
      >
        <Main.Screen name="home_remastered" options={{ title: "Home" }} component={HomeScreenRM} />
        <Main.Screen name="my-games" options={{ title: "My Games" }} component={MyGamesScreen} />
        <Main.Screen name="my-groups" options={{ title: "My Teams" }} component={MyGroupsScreen} />
        <Main.Screen name="eqipa-card" options={{ title: "My Player Profile" }} component={EqipaCardScreen} />
        <Main.Screen name="create-group" options={{ title: "Create Team" }} component={CreateGroupScreen} />
        <Main.Screen name="join-group" options={{ title: "Join Team" }} component={JoinGroupScreen} />
        <Main.Screen name="group" options={{ title: "My Teams" }} component={GroupScreenRM} />
        <Main.Screen
          name="game"
          component={GameScreen}
          options={{ swipeEnabled: false, title: "Game", unmountOnBlur: true }}
        />
        <Main.Screen name="new-game" component={NewGameScreen} />
        <Main.Screen name="stats" options={{ title: "Rankings" }} component={StatsScreen} />
        <Main.Screen name="profile" options={{ title: "Account" }} component={ProfileScreen} />
        <Main.Screen name="edit-game" component={EditGameScreen} options={{ title: "Edit Game" }} />
        <Main.Screen name="add-player" component={AddPlayerScreen} options={{ title: "Add Player" }} />
        <Main.Screen
          name="competitions-list"
          options={{ title: "Competitions" }}
          component={CompetitionsListScreen}
        />
        <Main.Screen name="competition-detail" component={CompetitionDetailScreen} options={{ title: "Competition" }} />
      </Main.Navigator>
    </AuthGuard>
  );
}
